import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nParams, TranslationProvider } from '../interfaces';
import { TRANSLATION_TOKEN } from '../tokens';

@Pipe({
  name: 'i18n',
  standalone: true,
  pure: false
})
export class I18nPipe implements PipeTransform {
  private readonly translationProvider: TranslationProvider = inject(TRANSLATION_TOKEN);

  transform(key: string, params?: I18nParams): string {
    return this.translationProvider.translate(key, params);
  }
}
